<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a2rwr2/tc-custom/9781429987615.jpg?1732131753251" alt="This image is the cover for the book Gemini Virus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gemini Virus
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This science-based thriller from Wil Mara will chill you to your core</b><br/>Bob Easton thinks he has a cold. Before he dies in agony, four days later, he infects dozens of people. Local health agencies become quickly overwhelmed by the sick and dying and beg the CDC for help. Dr. Michael Beck and Cara Porter, a member of the Epidemic Intelligence Service, race to identify the deadly bug. They can't cure it until they know what it is.<br/><br/>Dennis and Andi Jensen and their children are terrified. Schools and offices close. Fresh food disappears from store shelves. Three of their children's friends die. Their neighbors are dying or running away, fleeing the unstoppable infection. Desperate, the Jensens join the exodus, making a nightmarish journey to their isolated mountain cabin along empty roads, through abandoned towns, past looted shopping malls. <br/><br/>The superbug—and the panic—quickly spreads beyond America's borders. On a packed plane, someone coughs—and at their destination, the pilots are told, "you can't land here." US military bases are quarantined. Yet the virus continues to spread. Some believe the plague is man-made. Others see it as a sign of the end times.<br/><br/>In the lab, Cara Porter makes a potentially fatal mistake. In the mountains, Andi Jensen tells her husband that she doesn't feel well. <br/><br/>The world is running out of time. <br/><br/>"Irwin Allen's disaster films meet Stephen King's <i>The Stand</i>. A scary notion."—<i>Booklist </i><br/>"A chilling and horrific outbreak story. If you're a fan of <i>Outbreak</i>, <i>The Hot Zone</i>, and <i>Contagion</i> (the movie), you'll love <i>Gemini Virus</i>."—<i>No More Grumpy Bookseller</i><br/><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wil Mara
      </h2>
      
      <p class="authorDescription body article"><P>Wil Mara is the award-winning novelist of the 2005 disaster thriller <I>Wave</I>, as well as many other titles for variety of audiences. <I>The Gemini Virus</I> is the second book in the disaster series, with several more stories currently in development.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?150edcf2